import { clsx, type ClassValue } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [
        'text-h-24', 'text-h-20', 'text-h-18', 'text-h-16', 'text-h-14', 'text-h-12',
        'text-body', 'text-small', 'text-label', 'text-caption',
      ],
    },
  },
})

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
